<!--<form [formGroup]="formulario" class="example-form">
<mat-card class="example-card">
  <mat-card-header>
    <mat-card-title>Login</mat-card-title>
  </mat-card-header>
  <img mat-card-image class="card-login" height="252px" width="252px" src="./assets/logo1.png" alt="Photo of a Shiba Inu">
  <mat-card-content>

      <table class="example-full-width" cellspacing="0">
        <tr>
          <td>
            <mat-form-field class="example-full-width">
              <input matInput placeholder="Username" formControlName="username" name="username" required>
            </mat-form-field>
          </td>
        </tr>
        <tr>
          <td>
            <mat-form-field class="example-full-width">
              <input matInput placeholder="Password" type="password" formControlName="password" name="password" required>
            </mat-form-field>
          </td>
        </tr>
      </table>
    <mat-spinner [diameter]="30" *ngIf="iniciandoSesion" style="margin:0 auto; top:15px;"></mat-spinner>
  </mat-card-content>
  <mat-card-actions class="button-login">

    <button mat-raised-button (click)="onSubmit()" color="primary">
        <mat-icon>input</mat-icon>
      Login
    </button>
  </mat-card-actions>
</mat-card>
</form>-->

<div class="contenedor">
  <div class="layer">
    <form [formGroup]="formulario" class="example-form">
      <mat-card class="example-card">
        <div>
            <!--<img mat-card-image class="card-login img-logo" src="./assets/logo-letras.png" alt="Photo of a Shiba Inu">-->
            <img mat-card-image class="card-login img-logo" src="./assets/profile.png" alt="Photo of a Shiba Inu">
        </div>
        <!--<mat-card-header style="justify-content:center;">
          <mat-card-title style="font-weight:bolder;">Ingreso Aplicación</mat-card-title>
        </mat-card-header>-->

        <mat-card-content>

          <table class="example-full-width" cellspacing="0">
            <tr>
              <td>
                <mat-form-field class="example-full-width">
                  <input matInput placeholder="Usuario" formControlName="username" name="username" required>
                </mat-form-field>
              </td>
            </tr>
            <tr>
              <td>
                <mat-form-field class="example-full-width">
                  <input matInput placeholder="Clave" type="password" formControlName="password" name="password"
                    required>
                </mat-form-field>
              </td>
            </tr>
          </table>
          <mat-spinner [diameter]="30" *ngIf="iniciandoSesion" style="margin:0 auto; top:15px;"></mat-spinner>
        </mat-card-content>
        <mat-card-actions class="button-login">

          <button mat-raised-button (click)="onSubmit()" color="primary">
            <mat-icon>input</mat-icon>
            Login
          </button>
        </mat-card-actions>
      </mat-card>
    </form>
  </div>
</div>
